<template>
    <div class="dialog-spinner" >
        <v-layout justify-center >
            <v-progress-circular indeterminate color="primary" class="spinner-progress" />
        </v-layout>
    </div>
</template>

<script>
export default {
    name: "SpinnerComponent",
}
</script>

<style scoped>
    .dialog-spinner{
        position: fixed!important;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        z-index: 1000;
        opacity: 0.5;
        background-color: #FFFFFF;
        visibility: visible;
        overflow: hidden;
    }
    .spinner-progress{
        position: absolute;
        top: 50vh;
    }
</style>
